<!--
 * @Author: cnb zhangguoxin19@crpcg.com
 * @Date: 2026-05-18 23:22:16
 * @LastEditors: cnb zhangguoxin19@crpcg.com
 * @LastEditTime: 2026-05-19 21:40:38
 * @FilePath: /survey_frontend/src/view/extInfopanel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="ext-infopanel-container">
    <div class="weui-cells">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <input
            class="weui-input"
            v-model="inputValue"
            placeholder="请输入信息"
            type="text"
          />
        </div>
      </div>
    </div>
    <div class="weui-btn-area">
      <button class="weui-btn weui-btn_primary" @click="handleSubmit">提交</button>
    </div>
  </div>
</template>

<script>
import { getExtInfopanelLinks } from '../api/index'
export default {
  name: 'extInfopanel',
  data () {
    return {
      inputValue: ''
    }
  },
  methods: {
    handleSubmit () {
      if (!this.inputValue.trim()) {
        this.$toast.info('请输入信息')
        return
      }
      if (this.inputValue.length < 4) {
        this.$toast.info('输入内容不能少于4个字符')
        return
      }
      if (this.inputValue.length >= 200) {
        this.$toast.info('输入内容不能超过200个字符')
        return
      }
      this.$dialog.show({
        title: '确认信息',
        content: `您输入的信息是${this.inputValue}`,
        showCancel: true,
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          try {
            this.$toast.loading('加载中', { duration: 0 })
            const res = await getExtInfopanelLinks({
              param: {
                extInput: this.inputValue
              }
            })
            this.$toast.hide()
            if (res.code === '0000' && res.result && res.result.surveyListUrl) {
              window.location.href = res.result.surveyListUrl
            } else {
              this.$toast.info('获取链接失败')
            }
          } catch (err) {
            this.$toast.hide()
            console.error('请求失败:', err)
            this.$toast.info('请求失败')
          }
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.ext-infopanel-container {
  min-height: 100vh;
  background-color: #ffffff;
  padding: 15px;
}
.weui-cells {
  background-color: #ffffff;
}
.weui-cell {
  padding: 10px 15px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
}
.weui-input {
  border: none;
  outline: none;
}
.weui-btn-area {
  margin-top: 15px;
}
.weui-btn-area .weui-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  line-height: 1.5;
}
</style>